import { motion, Variants } from "framer-motion";

const pieceVariants: Variants = {
  hidden: (i: number) => ({
    opacity: 0,
    y: -40 - i * 10,
    scale: 0.5,
  }),
  visible: (i: number) => ({
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      delay: i * 0.15,
      type: "spring",
      stiffness: 260,
      damping: 20,
    },
  }),
};

const spinVariants: Variants = {
  animate: {
    rotateY: [0, 360],
    transition: {
      repeat: Infinity,
      duration: 1.5,
      ease: "linear",
    },
  },
};

export default function LoadingAcorn() {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-neutral-200/80 z-50">
      <motion.svg
        width={120}
        height={120}
        viewBox="0 0 196 264"
        variants={spinVariants}
        animate="animate"
        role="img"
        aria-label="Loading"
        style={{ transformStyle: "preserve-3d" }}
        filter="url(#shadow)"
      >
        <defs>
          <filter id="shadow" x="-20%" y="-20%" width="140%" height="140%">
            <feDropShadow dx="0" dy="4" stdDeviation="4" floodColor="rgba(0,0,0,0.3)" />
          </filter>
          <radialGradient id="bodyGradient" cx="50%" cy="45%" r="60%">
            <stop offset="0%" stopColor="#38bdf8" />
            <stop offset="70%" stopColor="#0284c7" />
            <stop offset="100%" stopColor="#075985" />
          </radialGradient>
          <radialGradient id="capGradient" cx="50%" cy="40%" r="60%">
            <stop offset="0%" stopColor="#0ea5e9" />
            <stop offset="60%" stopColor="#0369a1" />
            <stop offset="100%" stopColor="#0c4a6e" />
          </radialGradient>
          <linearGradient
            id="stemGradient"
            x1="100.5"
            y1="28"
            x2="100.5"
            y2="-18"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0%" stopColor="#0c4a6e" />
            <stop offset="50%" stopColor="#075985" />
            <stop offset="100%" stopColor="#0369a1" />
          </linearGradient>
        </defs>
        <motion.path
          custom={0}
          variants={pieceVariants}
          initial="hidden"
          animate="visible"
          d="M0.359061 131.347C0.406214 120.533 2.97341 109.834 7.91407 99.8604C12.8547 89.887 20.0721 80.8347 29.1541 73.2203C38.2361 65.6059 49.0049 59.5785 60.8456 55.4822C72.6863 51.3859 85.367 49.301 98.1637 49.3465C110.96 49.392 123.623 51.5671 135.427 55.7474C147.232 59.9278 157.948 66.0316 166.963 73.7104C175.978 81.3891 183.116 90.4925 187.97 100.501C192.824 110.509 195.297 121.226 195.25 132.04L97.8046 131.693L0.359061 131.347Z"
          fill="url(#capGradient)"
        />
        <motion.path
          custom={1}
          variants={pieceVariants}
          initial="hidden"
          animate="visible"
          d="M196 138C196 154.547 193.478 170.931 188.578 186.218C183.678 201.505 176.497 215.395 167.443 227.095C158.389 238.796 147.641 248.077 135.812 254.409C123.982 260.741 111.304 264 98.5 264C85.6961 264 73.0176 260.741 61.1884 254.409C49.3591 248.077 38.6108 238.796 29.5571 227.095C20.5034 215.395 13.3216 201.505 8.42174 186.218C3.52191 170.931 0.999999 154.547 1 138L98.5 138H196Z"
          fill="url(#bodyGradient)"
        />
        <motion.g
          custom={2}
          variants={pieceVariants}
          initial="hidden"
          animate="visible"
        >
          <motion.rect
            x="87.2637"
            y="7.84747"
            width="27"
            height="26"
            transform="rotate(10.02 87.2637 7.84747)"
            fill="url(#stemGradient)"
          />
          <motion.ellipse
            cx="96.208"
            cy="34.815"
            rx="13.5"
            ry="11"
            transform="rotate(10.02 96.208 34.815)"
            fill="url(#stemGradient)"
          />
          <motion.ellipse
            cx="100.384"
            cy="11.1811"
            rx="13.5"
            ry="11"
            transform="rotate(10.02 100.384 11.1811)"
            fill="url(#stemGradient)"
          />
        </motion.g>
      </motion.svg>
    </div>
  );
}

